module.exports = __webpack_public_path__ + "static/media/do-not-agree.6f2c6a87.svg";